import { Card, Col, Empty, Spin, Typography } from "antd";

import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../hooks/useNotification";
import NotificationItem from "./NotificationItem";

const { Title, Text } = Typography;

const NotificationsCard = () => {
  const navigate = useNavigate();

  const { notifications, loading, handleNotificationClick, handleMarkAsRead } =
    useNotifications(5);

  return (
    <Col xs={24} md={24} lg={12}>
      <Card
        style={{
          background: "rgba(88, 80, 109, 0.30)",
          borderRadius: 16,
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <Title level={5} style={{ color: "#fff" }}>
            Notifications
          </Title>
          <Text
            style={{ color: "#a855f7", cursor: "pointer" }}
            onClick={() => navigate("/notifications")}
          >
            View All →
          </Text>
        </div>

        {loading ? (
          <Spin />
        ) : notifications.length === 0 ? (
          <Empty style={{ color: "#9ca3af" }}>
            No notifications available.
          </Empty>
        ) : (
          notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onNotificationClick={handleNotificationClick}
              onMarkAsRead={handleMarkAsRead}
            />
          ))
        )}
      </Card>
    </Col>
  );
};

export default NotificationsCard;
